"use client";
const n = `query GetSearchResults($searchInput: SearchInput!) {
  search(searchInput: $searchInput) {
    searchHits {
      id
      hitOnRoot
      url
      title
      preview

      ... on DocumentationHit {
        rootRecord {
          __typename
          id
          title
          url
          preview
          ... on DocumentationRecord {
            pathBreadcrumbs
            contentType
            topLevelHeadings {
              anchor
              url
              content
            }
          }
        }
        pathHeadings {
          anchor
          content
        }
        content {
          anchor
          content
        }
      }

      ... on StackOverflowHit {
        rootRecord {
          __typename
          id
          title
          url
          preview
          ... on StackOverflowRecord {
            body
            createdAt

            markedAsCorrectAnswer {
              url
              score
              content
            }
          }
        }
      }

      ... on GitHubIssueHit {
        rootRecord {
          __typename
          id
          title
          url
          preview
          ... on GitHubIssueRecord {
            createdAt
            body
            state
          }
        }
      }

      ... on DiscourseHit {
        rootRecord {
          __typename
          id
          title
          url
          preview
          ... on DiscourseRecord {
            createdAt
            body
          }
        }
      }
    }
    searchQuery
  }
}
`;
export {
  n as default
};
